import { render, staticRenderFns } from "./BankAccountList.vue?vue&type=template&id=304007c8&scoped=true&"
import script from "./BankAccountList.vue?vue&type=script&lang=ts&"
export * from "./BankAccountList.vue?vue&type=script&lang=ts&"
import style0 from "./BankAccountList.vue?vue&type=style&index=0&id=304007c8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304007c8",
  null
  
)

export default component.exports